import { render, staticRenderFns } from "./analyticsDashboardValueRow.vue?vue&type=template&id=60ea47ba&scoped=true&"
var script = {}
import style0 from "./analyticsDashboardValueRow.vue?vue&type=style&index=0&id=60ea47ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ea47ba",
  null
  
)

export default component.exports